import { render, staticRenderFns } from "./ActionMannerFeedback.vue?vue&type=template&id=22025a28&scoped=true&"
import script from "./ActionMannerFeedback.vue?vue&type=script&lang=js&"
export * from "./ActionMannerFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ActionMannerFeedback.vue?vue&type=style&index=0&id=22025a28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22025a28",
  null
  
)

export default component.exports